exports.f = require('./_wks');



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/core-js/modules/_wks-ext.js
// module id = Jnk4
// module chunks = 1